"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Map_1 = __importDefault(require("ol/Map"));
var Vector_1 = __importDefault(require("ol/layer/Vector"));
var Vector_2 = __importDefault(require("ol/source/Vector"));
var Point_1 = __importDefault(require("ol/geom/Point"));
var LineString_1 = __importDefault(require("ol/geom/LineString"));
var Polygon_1 = __importDefault(require("ol/geom/Polygon"));
var Feature_1 = __importDefault(require("ol/Feature"));
var View_1 = __importDefault(require("ol/View"));
var geostyler_openlayers_parser_1 = __importDefault(require("geostyler-openlayers-parser"));
require("./Renderer.css");
require("ol/ol.css");
var _isEqual = require('lodash/isEqual');
var _get = require('lodash/get');
var _uniqueId = require('lodash/uniqueId');
/**
 * Symbolizer Renderer UI.
 */
var Renderer = /** @class */ (function (_super) {
    __extends(Renderer, _super);
    function Renderer(props) {
        var _this = _super.call(this, props) || this;
        _this.getSampleGeomFromSymbolizer = function () {
            var _a = _this.props, symbolizerKind = _a.symbolizerKind, symbolizers = _a.symbolizers;
            var kind = symbolizerKind || _get(symbolizers, '[0].kind');
            switch (kind) {
                case 'Mark':
                case 'Icon':
                case 'Text':
                    return new Point_1.default([7.10066, 50.735851]);
                case 'Fill':
                    return new Polygon_1.default([[
                            [7.1031761169433585, 50.734268655851345],
                            [7.109270095825195, 50.734268655851345,],
                            [7.109270095825195, 50.73824770380063],
                            [7.1031761169433585, 50.73824770380063],
                            [7.1031761169433585, 50.734268655851345,]
                        ]]);
                case 'Line':
                    return new LineString_1.default([
                        [7.062578201293945, 50.721786104206004],
                        [7.077512741088867, 50.729610159968296],
                        [7.082319259643555, 50.732435192351126],
                        [7.097940444946289, 50.73748722929948],
                        [7.106866836547852, 50.73775882875318],
                        [7.117509841918945, 50.73889952925885],
                        [7.129182815551758, 50.7504679214779]
                    ]);
                default:
                    return new Point_1.default([7.10066, 50.735851]);
            }
        };
        /**
         * Transforms the incoming symbolizers to an OpenLayers style object the
         * GeoStyler parser and applies it to the vector features on the map.
         *
         * @param {Symbolizer[]} symbolizers The symbolizers holding the style to apply
         */
        _this.applySymbolizers = function (symbolizers) {
            var styleParser = new geostyler_openlayers_parser_1.default();
            // we have to wrap the symbolizer in a Style object since the writeStyle
            // only accepts a Style object
            var style = {
                name: 'WrapperStyle4Symbolizer',
                rules: [{
                        name: 'WrapperRule4Symbolizer',
                        symbolizers: symbolizers
                    }]
            };
            // parser style to OL style
            styleParser.writeStyle(style)
                .then(function (olStyles) {
                // apply new OL style to vector layer
                _this._layer.setStyle(olStyles);
                return olStyles;
            })
                .catch(function () {
                return;
            });
        };
        _this._mapId = _uniqueId('map_');
        return _this;
    }
    Renderer.prototype.componentDidMount = function () {
        var symbolizers = this.props.symbolizers;
        this._layer = new Vector_1.default({
            source: new Vector_2.default()
        });
        this._map = new Map_1.default({
            layers: [this._layer],
            controls: [],
            interactions: [],
            target: this._mapId,
            view: new View_1.default({
                projection: 'EPSG:4326'
            })
        });
        this.updateFeature();
        this.applySymbolizers(symbolizers);
    };
    Renderer.prototype.componentDidUpdate = function (prevProps) {
        var symbolizers = this.props.symbolizers;
        if (!_isEqual(symbolizers, prevProps.symbolizers)) {
            this.updateFeature();
            this.applySymbolizers(symbolizers);
        }
    };
    Renderer.prototype.updateFeature = function () {
        var data = this.props.data;
        var exampleFeatureProps = _get(data, 'exampleFeatures.features[0].properties');
        this._layer.getSource().clear();
        var sampleFeature = new Feature_1.default(__assign({ geometry: this.getSampleGeomFromSymbolizer(), Name: 'Sample Feature' }, exampleFeatureProps));
        this._layer.getSource().addFeature(sampleFeature);
        // zoom to feature extent
        var extent = this._layer.getSource().getExtent();
        this._map.getView().fit(extent, {
            maxZoom: 20
        });
    };
    Renderer.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, symbolizers = _a.symbolizers;
        return (React.createElement("div", { onClick: function (event) {
                if (onClick) {
                    onClick(symbolizers, event);
                }
            }, className: "gs-symbolizer-renderer", id: this._mapId }));
    };
    return Renderer;
}(React.Component));
exports.Renderer = Renderer;
exports.default = Renderer;
//# sourceMappingURL=Renderer.js.map